import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgChevronRight = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.56896 3.34408C6.78384 3.14262 7.12136 3.15351 7.32282 3.3684L11.3228 7.63507C11.5151 7.84021 11.5151 8.15945 11.3228 8.3646L7.32282 12.6312C7.12136 12.8462 6.78384 12.8571 6.56896 12.6556C6.35407 12.4541 6.34318 12.1166 6.54464 11.9018L10.2027 7.99984L6.54464 4.09794C6.34318 3.88305 6.35407 3.54553 6.56896 3.34408Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgChevronRight)
const IconSvgChevronRight = createIcon(ForwardRef, 'SvgChevronRight')
export default IconSvgChevronRight
